module.exports = __webpack_public_path__ + "img/bc_pic3.666cb1bf.png";